import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import render from './render'

export default {
  name: 'ButtonConfirmRemove',

  props: {
    callback: {
      type: Function,
      default: undefined
    },

    component: {
      type: String,
      default: 'button',
      validator: value => {
        return [ components.button, components['list-item'], 'button' ].includes(value)
      }
    },

    icon: {
      type: String,
      default: icons.delete,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },
    size: {
      type: String,
      default: sizes.medium,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    },
    color: {
      type: String,
      default: Colors.error,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    tooltip: String,

    labeled: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },

    loading: Boolean,
    disabled: Boolean
  },

  data() {
    return {
      showDialog: false
    }
  },

  computed: {
    $props() {
      let label
      if (this.labeled) {
        label = this.getTranslate('misc.buttons.remove')
      }

      let icon
      if (this.showIcon) {
        icon = this.icon
      }

      const result = {
        label,
        icon,
        color: this.color,
        tooltip: this.tooltip,
        loading: this.loading,
        disabled: this.loading || this.disabled
      }

      switch (this.component) {
        case components.button: {
          result.flat = true
          result.rounded = true
          break
        }
        case components['list-item']: {
          result.icon = icon
          result.iconColor = this.color
          result.dense = true
          result.color = undefined
          break
        }
        case 'button': {
          result.mode = buttonModes.flat,
          result.size = this.size
          result.fullWidth = this.fullWidth
          break
        }
      }

      return result
    }
  },

  methods: {
    onClick(event) {
      if (this.component !== components['list-item']) {
        event.stopPropagation()
      }
      this.showDialog = true
    },
    async onRemove() {
      await this.callback()
      this.showDialog = false
    }
  },

  render
}
